/**
 * CẦU NỐI: màn `sale4` của quiz → trang bán trên Shopify.
 *
 * Vì sao là file RIÊNG, không sửa vào `quiz-inner-weather.js`:
 * file kia được bê NGUYÊN từ minespirit-quiz.pages.dev. Sửa tay vào đó thì lần bê lại sau
 * là mất vá, im lặng. Quiz để lọt `RENDER`, `res7`, `SCREENS`, `goto`, `idxOf` ra phạm vi
 * toàn cục (đo 26/08/2026), nên đè được từ ngoài — file bê nguyên không phải đụng một dòng.
 *
 * Cách chạy: thay hàm dựng màn `sale4`. Mọi đường tới màn đó đều đi qua `RENDER.sale4`
 * (nút dính `#unlock`, nút `.ctac`, `toSale()`), nên chỉ cần chặn một chỗ là chặn hết —
 * không phải đi tìm từng nút.
 *
 * Đích đến do Liquid truyền vào qua `data-dich-ban` trên `#phone`, KHÔNG viết cứng ở đây:
 * đổi handle sản phẩm là việc của người dựng trang, không nên bắt sửa file JS.
 *
 * Không có `data-dich-ban` → không đè gì cả, quiz chạy tiếp màn bán nội bộ như cũ.
 * Đây là mặc định AN TOÀN: cấu hình thiếu thì mất doanh thu ở bước sau, còn chuyển hướng
 * vào một URL rỗng thì mất khách ngay tại chỗ.
 */
(function () {
  var goc = document.getElementById('phone');
  var dich = goc && goc.getAttribute('data-dich-ban');
  if (!dich) return;

  /* Chỉ nhận đường dẫn nội bộ. `data-*` đến từ cài đặt section — người dựng trang gõ tay,
     gõ nhầm thành một địa chỉ ngoài thì đây thành cửa đẩy khách sang site lạ. */
  if (dich.charAt(0) !== '/' || dich.charAt(1) === '/') return;

  if (typeof RENDER !== 'object' || typeof RENDER.sale4 !== 'function') return;

  /* Chỉ HAI kiểu kết quả mới thật sự có một tầng mỏng nhất để gọi tên.
     Kiểu khác thì `edge` chỉ là kết quả phá hoà theo thứ tự tầng, không phải tín hiệu:
       HIGH  — bảy tầng đều cao (đo ?demo=high: cả bảy = 10, `edge` vẫn trả 'ground')
       LOW   — bảy tầng đều thấp (đo ?demo=low: sáu tầng bằng 0, `edge` trả 'joy')
       FLAT  — chênh lệch giữa cao nhất và thấp nhất ≤ 1
     Gửi trục trong ba kiểu này là nói với người vừa đọc "mọi tầng của bạn đều ổn" rằng
     "nghỉ ngơi là chỗ mỏng nhất của bạn" — mâu thuẫn ngay tại giây bán hàng.
     Không gửi thì trang bán rơi về bản chào chung, đúng luật đã ghi trong hợp đồng:
     đoán bừa một trục còn tệ hơn không đoán. */
  var KIEU_CO_TRUC = { NORMAL: 1, HEART_OVERLOADED: 1 };

  function diThoi() {
    var ma = '';
    try {
      /* res7().edge = tầng mỏng nhất, một trong bảy khoá:
         ground · joy · line · heart · voice · mind · meaning
         (đo bằng ?demo=margaret ngày 26/08/2026 → 'ground'). */
      var r = res7() || {};
      if (KIEU_CO_TRUC[r.mode]) ma = r.edge || '';
      guiBanDo(r);
    } catch (e) {
      /* Vào thẳng màn bán mà chưa trả lời câu nào. Đi tiếp, chỉ là không có trục —
         trang bán rơi về bản chào chung, đúng như hợp đồng. */
      ma = '';
    }

    var url = dich + (ma ? (dich.indexOf('?') === -1 ? '?' : '&') + 'axis=' + encodeURIComponent(ma) : '');
    window.location.assign(url);
  }

  /**
   * Gửi BẢN ĐỒ tóm tắt sang trang bán, qua localStorage.
   *
   * Đi được vì từ lúc quiz vào theme thì quiz và trang bán CÙNG MỘT tên miền. Không cần
   * máy chủ, và KHÔNG nhét gì vào URL — query string nằm lại trong log máy chủ, trong header
   * Referer gửi sang bên thứ ba, và trong lịch sử trình duyệt của máy dùng chung.
   *
   * CHỈ lưu phần ĐÃ DẪN XUẤT: bảy điểm tầng, tầng mỏng nhất, kiểu kết quả, chỉ số chung.
   * TUYỆT ĐỐI KHÔNG lưu ngày sinh · giờ sinh · nơi sinh · tên · email. Tệp khách 45–65 hay
   * dùng máy chung trong nhà; người mở sau đọc được là hỏng.
   */
  var KHOA_BAN_DO = 'minespirit_ban_do';


  /* Lá số sinh cho trang bán — CHỈ phần THẤY.
     `_chart` mang cả `timeline`, `knots`, `humanDesign`, `aspects`: đó là phần diễn giải,
     tức thứ khách trả $4,90 để đọc. Nhét cả cục vào localStorage là tự phát không phần
     mình đang bán, và ai mở DevTools cũng đọc được.
     Nên chỉ lấy cung mọc và bảy hành tinh cổ điển: vị trí thì nhìn thấy được, ý nghĩa thì không. */
  var SAO = ['Sun', 'Moon', 'Mercury', 'Venus', 'Mars', 'Jupiter', 'Saturn'];

  function laySao() {
    try {
      var c = (typeof _chart !== 'undefined') ? _chart : null;
      if (!c || !c.planets) return null;
      var ra = { asc: null, sao: [] };
      if (c.asc && c.asc.sign) ra.asc = { cung: c.asc.sign, do: c.asc.degText || '' };
      for (var i = 0; i < SAO.length; i++) {
        var pl = c.planets[SAO[i]];
        if (pl && pl.sign) ra.sao.push({ ten: SAO[i], cung: pl.sign, do: pl.degText || '' });
      }
      return ra.sao.length ? ra : null;
    } catch (e) {
      /* Chưa chấm xong lá số, hoặc bản quiz về sau đổi tên biến. Trang bán vẫn vẽ biểu đồ
         bảy tầng như cũ, chỉ thiếu khối lá số. */
      return null;
    }
  }

  function guiBanDo(r) {
    try {
      if (!r || !r.axes) return;
      var diem = {};
      var ten = ['ground', 'joy', 'line', 'heart', 'voice', 'mind', 'meaning'];
      for (var i = 0; i < ten.length; i++) {
        var v = Number(r.axes[ten[i]]);
        if (isFinite(v)) diem[ten[i]] = Math.round(v * 10) / 10;
      }
      localStorage.setItem(KHOA_BAN_DO, JSON.stringify({
        v: 1,
        diem: diem,
        sao: laySao(),
        mong_nhat: r.edge || '',
        kieu: r.mode || '',
        chi_so: isFinite(r.index) ? r.index : null,
        luc: Date.now()
      }));
    } catch (e) {
      /* Cửa sổ riêng tư hoặc trình duyệt chặn lưu trữ. Bỏ qua — trang bán sẽ ẩn khối bản đồ,
         luồng mua vẫn chạy bình thường. */
    }
  }

  /* ─────────────────────────────────────────────────────────────────────────
     MÀN BÁN CỦA QUIZ ĐI THẲNG TỚI THANH TOÁN

     Trước đây khối này BỎ QUA màn bán và đẩy khách sang trang bán Shopify. Nay giữ
     nguyên màn bán của quiz — nó giàu hơn (đồng hồ, mã giảm, bốn phần, neo $100) — và
     chỉ chặn nút mua: thêm gói vào giỏ rồi vào thẳng màn nhập thẻ.

     Làm được vì quiz nằm CÙNG TÊN MIỀN với cửa hàng, nên gọi `/cart/add.js` được.
     Đo 28/08: giữ nguyên `properties`, nên trục yếu vẫn theo đơn hàng.

     Không khai `data-variant-goi` → giữ đường cũ, chuyển sang trang bán. Cấu hình thiếu
     thì chậm một nhịp, còn hơn nút bấm không ra gì.
     ───────────────────────────────────────────────────────────────────────── */
  var variantGoi = (goc.getAttribute('data-variant-goi') || '').trim();
  /* Ô này người dựng trang gõ tay. Dán nhầm GID `gid://shopify/ProductVariant/...` hay chuỗi
     có chữ thì `Number()` ra NaN, `/cart/add.js` lỗi MỖI lần bấm rồi mới rơi về đường cũ —
     tính năng tắt câm mà nhìn vẫn như đang chạy. Sai dạng thì bỏ ngay từ đầu. */
  if (!/^\d+$/.test(variantGoi)) variantGoi = '';

  /* Gói cao ($19 · Bản đồ & Báo cáo + 5 Giải pháp). Cùng luật kiểm dạng với gói thấp.
     KHÔNG khai ô này → khối chào hàng chỉ bày một gói, đúng như trước 08/09/2026. Không
     có bậc thang nửa vời: thiếu mã biến thể mà vẫn bày radio thì khách chọn xong bấm mua
     lại rơi về gói kia, mất tiền theo đúng nghĩa đen. */
  var variantGoiCao = (goc.getAttribute('data-variant-goi-cao') || '').trim();
  if (!/^\d+$/.test(variantGoiCao)) variantGoiCao = '';

  /* Vé Storefront API của kênh Headless "Mine Spirit Headless". Vé CÔNG KHAI theo thiết kế
     của Shopify — nó chỉ mở đúng những gì kênh đó được cấp (dựng giỏ, đọc danh mục), nên nằm
     trong mã trang là đúng chỗ, không phải là rò rỉ.

     Không khai ô này → nút mua giữ nguyên đường cũ (giỏ chung). Sai dạng cũng bỏ, cùng lý do
     với hai ô mã biến thể ở trên: tính năng tắt câm mà nhìn vẫn như đang chạy là tệ nhất. */
  var veCuaHang = (goc.getAttribute('data-storefront-token') || '').trim();
  if (!/^[0-9a-f]{32}$/i.test(veCuaHang)) veCuaHang = '';

  /* Ghim phiên bản API. Để `unstable` hay bỏ trống là nhận thay đổi phá vỡ vào đúng đường
     thu tiền, không báo trước. */
  var BAN_API_CUA_HANG = '2026-10';

  function truc() {
    try {
      var r = res7() || {};
      return KIEU_CO_TRUC[r.mode] ? (r.edge || '') : '';
    } catch (e) { return ''; }
  }

  /* Mã phiên do `/api/quiz/submit` cấp. Nó phải đi vào giỏ dưới dạng THUỘC TÍNH CẤP ĐƠN,
     không phải thuộc tính dòng hàng — webhook của bên API đọc `note_attributes` để biết đơn
     nào ứng với phiên nào rồi mới mở khoá bản đọc. `/cart/add.js` không đặt được thứ này,
     phải gọi thêm `/cart/update.js`.
     Chưa có mã thì bỏ qua: luồng mua vẫn chạy, chỉ là bản đọc phải mở bằng đường khác.
     (`ganPhienVaoGio` vẫn có thể gắn `_ms_cid`/`_ms_sid` khi chưa có mã — xem `layThuocKhach`.) */
  var KHOA_PHIEN = 'minespirit_phien';

  function layPhien() {
    try {
      var v = (sessionStorage.getItem(KHOA_PHIEN) || localStorage.getItem(KHOA_PHIEN) || '').trim();
      return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(v) ? v : '';
    } catch (e) { return ''; }
  }

  /* Bộ đáp án của lượt (`quiz-goi-api.js` cất lúc màn kết quả dựng, trước mọi lượt gọi mạng)
     — đi vào đơn dưới thuộc tính cấp đơn `_quiz_ans`, ĐỘC LẬP với mã phiên. Webhook bên API
     thấy đơn không có `quiz_session` thì tự dựng phiên từ nó: submit hỏng mà khách vẫn mở được
     bản đọc (đơn #1033, 15/09/2026). Dấu `_` để Shopify ẩn nó khỏi checkout và email đơn.
     Máy chủ bỏ qua bản dài quá 4000 ký tự, nên bỏ luôn từ đây. */
  var KHOA_BAI = 'minespirit_bai';

  function layBai() {
    try {
      var v = sessionStorage.getItem(KHOA_BAI) || '';
      return v.length <= 4000 ? v : '';
    } catch (e) { return ''; }
  }

  /* Khách + phiên của tracker first-party, để nối đơn thật với khách (`order_paid` từ webhook
     đọc `note_attributes` `_ms_cid`/`_ms_sid`). `snippets/brand-ms-gan-khach.liquid` phơi hàm
     này: chỉ trả khoá có cookie hợp lệ và chỉ khi consent cho phép, `{}` nếu không — cùng cổng
     với chỗ gắn vào giỏ đang có. Giỏ do `cartCreate` dựng là giỏ MỚI nên snippet không với tới
     được, phải nhét vào ngay lúc dựng. Hỏng thì bỏ qua: mất phần nối đơn với khách, không mất đơn. */
  /* Tham số quảng cáo của trang đáp lên URL giỏ/checkout — `snippets/brand-giu-utm.liquid`. */
  function giuUtm(url) {
    return typeof window.__msGiuUtm === 'function' ? window.__msGiuUtm(url) : url;
  }

  function layThuocKhach() {
    try { return (typeof window.__msThuocKhach === 'function' && window.__msThuocKhach()) || {}; }
    catch (e) { return {}; }
  }

  /* Mã giỏ để dựng permalink `/cart/c/`. Shopify trả `token` kèm sẵn `?key=...` trên store
     này (đo 09/09/2026), nhưng dạng token trần cũng từng tồn tại — nên chỗ ghép query phải
     xét dấu `?` chứ đừng viết cứng. Hụt thì trả chuỗi rỗng, người gọi tự rơi về `/checkout`. */
  function layTokenGio() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (gio) {
        var t = gio && typeof gio.token === 'string' ? gio.token.trim() : '';
        return t;
      })['catch'](function () { return ''; });
  }

  function ganPhienVaoGio(ma, bai) {
    var thuoc = {};
    if (ma) thuoc.quiz_session = ma;
    if (bai) thuoc._quiz_ans = bai;
    var khach = layThuocKhach();
    if (khach._ms_cid) thuoc._ms_cid = khach._ms_cid;
    if (khach._ms_sid) thuoc._ms_sid = khach._ms_sid;
    if (khach._ms_c) thuoc._ms_c = khach._ms_c;
    if (!Object.keys(thuoc).length) return Promise.resolve();
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: thuoc })
    })['catch'](function () {
      /* Gắn hụt thì đừng chặn đường mua. Mất phần nối đơn với phiên, không mất đơn. */
    });
  }

  /* Đợi lượt gửi bài đang bay (`window.__msPhienDangBay`, do `quiz-goi-api.js` phơi) xong
     rồi mới đọc mã phiên. Khách bấm mua ngay khi màn kết quả vừa dựng là bấm TRƯỚC khi
     `/api/quiz/submit` trả `session_id`: đơn #1024 (08/09) rỗng mã, đơn #1022 chỉ có mã cấp
     đơn vì submit xong đúng giữa hai lần đọc storage. Đợi có hạn — submit treo thì vẫn cho
     mua, thà đơn thiếu mã còn hơn nút chết.

     Trần hạ 4000 → 1500 ngày 15/09/2026. Đo trên live cùng ngày: bấm đúng lúc lượt gửi còn
     bay thì `cartCreate` mãi tới mốc 4.010 ms mới khởi hành, tổng ~5,1 giây mới sang được
     checkout — còn khi không phải đợi thì chỉ 1,9 giây. Ba giây chênh ấy là ngồi không, và
     khách đọc nó là "bấm hụt". Mất mã phiên ở nhánh hiếm này KHÔNG còn nghĩa là mất bản đọc:
     `_quiz_ans` đi kèm đơn từ 15/09 nên webhook tự dựng lại phiên (đơn #1033).
     Đường chính bây giờ là giỏ dựng sẵn ở dưới — trần này chỉ còn là lưới đỡ. */
  var DOI_PHIEN_TOI_DA_MS = 1500;

  function doiPhien() {
    return coHan(window.__msPhienDangBay, DOI_PHIEN_TOI_DA_MS);
  }

  /* ─────────────────────────────────────────────────────────
     NÚT PHẢI NÓI RẰNG NÓ ĐANG CHẠY

     Đo trên live 15/09/2026, chụp trạng thái nút ở các mốc 0 · 50 · 500 · 1000 · 2000 · 3000
     · 4000 · 5000 ms sau cú bấm: `disabled` và `aria-busy` đều được đặt, nhưng `opacity` vẫn
     là 1 và chữ vẫn nguyên — luật `.btn[disabled]{opacity:.34}` của quiz bị class `gd1-mua`
     ghi đè. Nhìn bằng mắt thì nút y hệt lúc chưa bấm, suốt năm giây liền. Khách bấm, không
     thấy gì, bấm lại, vẫn không thấy gì, rồi bỏ đi.

     Đặt ở ĐÂY chứ không ở chỗ dựng nút: mọi nút đi tới thanh toán đều chui qua `muaNgay()`,
     nên một chỗ là đủ cho cả nút trong quiz lẫn nút gọi từ trang bán.

     CSS chèn bằng JS chứ không bỏ vào `quiz-giai-doan-1.css`: file css đó chỉ nạp trên trang
     quiz, còn file js này còn chạy ở nơi khác. Chèn một lần, tự bảo vệ bằng cờ. */
  var daChenCss = false;

  function chenCss() {
    if (daChenCss) return;
    daChenCss = true;
    try {
      var st = document.createElement('style');
      /* `!important` ở đúng hai thuộc tính này, không hơn. Đo trên bàn thử 15/09/2026:
         không có nó thì `opacity` của nút vẫn là 1 — `.btn[disabled]` (0,2,0) và `.btn.gd1-mua`
         của quiz đều chuyên biệt hơn `.ms-dang-chay` (0,1,0) nên thắng, và cái mờ đi không
         bao giờ xảy ra. Đây là luật trạng thái tạm, chỉ sống trong lúc nút đang chạy.

         Vòng xoay là một THẺ CON, không phải `::after`. Bản đầu dùng `::after` và hỏng câm:
         nút CTA của quiz đã xài chính pseudo-element đó cho hiệu ứng quầng sáng
         (`animation: gd1-quang`, đo trên bàn thử cùng ngày) — hai luật giẫm nhau, vòng xoay
         không quay mà quầng sáng cũng có thể mất. Thẻ con thì không tranh với ai. */
      st.textContent =
        '.ms-dang-chay{opacity:.72!important;cursor:progress!important}' +
        '.ms-xoay-icon{display:inline-block;width:1em;height:1em;' +
        'margin-left:.5em;vertical-align:-.15em;border:2px solid currentColor;' +
        'border-right-color:transparent;border-radius:50%;animation:ms-xoay .7s linear infinite}' +
        '@keyframes ms-xoay{to{transform:rotate(360deg)}}' +
        '@media (prefers-reduced-motion:reduce){.ms-xoay-icon{animation-duration:2.4s}}';
      (document.head || document.documentElement).appendChild(st);
    } catch (e) { /* Không chèn được thì nút vẫn đổi chữ — phần chữ mới là phần quan trọng. */ }
  }

  function laVI() {
    try { return (typeof state === 'object' && state && state.lang === 'vi'); } catch (e) { return false; }
  }

  function batDauChay(nut) {
    if (!nut) return;
    nut.disabled = true;
    nut.setAttribute('aria-busy', 'true');
    chenCss();
    /* Giữ nguyên bản cũ để `thoiChay()` trả lại được. Dùng `innerHTML` chứ không phải
       `textContent`: nút ở trang bán có thể mang thẻ con. */
    if (nut.getAttribute('data-ms-chu-cu') === null) {
      nut.setAttribute('data-ms-chu-cu', nut.innerHTML);
    }
    nut.textContent = laVI() ? 'Đang mở trang thanh toán…' : 'Taking you to checkout…';
    /* `createElement` chứ không phải chuỗi HTML: chữ vừa đặt ở trên đi qua `textContent` nên
       an toàn, đừng nối nó lại thành `innerHTML` rồi mở đường cho dấu nhọn lọt vào. */
    var xoay = document.createElement('span');
    xoay.className = 'ms-xoay-icon';
    xoay.setAttribute('aria-hidden', 'true');
    nut.appendChild(xoay);
    nut.className += (nut.className ? ' ' : '') + 'ms-dang-chay';
  }

  function thoiChay(nut) {
    if (!nut) return;
    nut.disabled = false;
    nut.removeAttribute('aria-busy');
    var cu = nut.getAttribute('data-ms-chu-cu');
    if (cu !== null) { nut.innerHTML = cu; nut.removeAttribute('data-ms-chu-cu'); }
    nut.className = nut.className.replace(/(^|\s)ms-dang-chay(?=\s|$)/g, '').replace(/^\s+|\s+$/g, '');
  }

  /* ─────────────────────────────────────────────────────────
     GIỎ DỰNG SẴN

     Đường mua tốn 0,87–1,08 giây chỉ cho riêng `cartCreate` (đo live 15/09/2026), cộng thời
     gian đợi mã phiên. Cả hai đều xảy ra SAU khi khách bấm, trong khi không có gì bắt chúng
     phải đợi tới lúc đó: mọi dữ liệu dựng giỏ đã đủ từ giây màn chào hàng hiện ra.

     Nên dựng giỏ trước, để lúc bấm chỉ còn một việc là điều hướng.

     Hai ràng buộc, thiếu cái nào cũng thành hồi quy:

     · DỰNG SAU KHI LƯỢT GỬI BÀI NGÃ NGŨ. Dựng sớm hơn thì giỏ thiếu `_quiz_session` —
       đúng lỗi đơn #1016/#1017/#1024. Nên chờ `__msPhienDangBay` xong (ok hay hỏng đều được)
       rồi mới gọi `cartCreate`.
     · CHỮ KÝ PHẢI KHỚP LÚC BẤM. Giữa lúc dựng và lúc bấm, khách còn có thể đổi gói, và mã
       phiên có thể vừa về. Giỏ dựng sẵn mang dữ liệu CŨ mà vẫn đem dùng thì đơn sai im lặng —
       nên so lại từng phần (mã biến thể · mã phiên · bài làm · trục · email · thuộc tính
       email · có nối khách hay không), lệch một phần là vứt giỏ sẵn, đi đường thường.

     Đánh đổi đã biết: khách xem màn chào hàng rồi bỏ đi sẽ để lại một giỏ trống bên Shopify.
     Giỏ `cartCreate` là giỏ độc lập, không đụng cookie `cart` của khách và tự hết hạn — không
     làm hỏng gì, chỉ là rác. */
  var gioSan = null;          /* { chuKy, maDat, url } */
  var gioSanDangBay = null;   /* Promise | null */

  /* Trần chờ RIÊNG cho việc dựng sẵn, tách khỏi trần của `doiPhien()`.

     Vì sao cần: bản đầu đợi `__msPhienDangBay` ngã ngũ KHÔNG giới hạn, để giỏ chắc chắn mang
     `_quiz_session`. Đo trên Chrome thật 16/09/2026 thì chuỗi ấy dài hơn tưởng — kể cả khi
     Turnstile chạy tốt: `layVe()` 4,2 giây + `/api/quiz/submit` 4,3 giây, nên mã phiên chỉ có ở
     giây ~10,6 kể từ lúc vào màn kết quả. Khách mở màn chào hàng ở giây 4 và bấm ngay thì rơi
     vào cửa sổ ~7 giây chưa có giỏ sẵn — đúng quãng nhiều người bấm nhất.

     Nên: đợi có hạn, quá hạn thì cứ dựng với những gì đang có. Bản dựng sớm thiếu mã phiên
     KHÔNG làm đơn mất mã, nhờ hai lớp:
       · mã phiên về muộn ⇒ chữ ký đổi ⇒ dựng LẠI (xem cổng chặn trong `dungSanGio`), và nếu
         khách bấm trước khi kịp dựng lại thì `urlGioSan()` thấy chữ ký lệch nên vứt giỏ cũ,
         đi đường thường và gắn mã đầy đủ;
       · `_quiz_ans` đã đi kèm đơn từ 15/09 nên webhook tự dựng lại phiên (đơn #1033). */
  var TRAN_DUNG_SAN_MS = 2000;

  /* Bốn thuộc tính email cũng vào chữ ký: khách lui về màn email sửa tên rồi quay lại thì
     giỏ dựng sẵn mang tên cũ — lệch là vứt, như các phần kia.

     Và HAI BIT "có `_ms_cid` / có `_ms_sid` hay không" cùng cờ `_ms_c` (gắn lúc consent chưa
     trả lời hay đã đồng ý): consent đổi giữa lúc dựng sẵn và lúc
     bấm (đồng ý sau, hoặc rút trước), hoặc cookie `ms_sid` hết hạn lúc dựng rồi `beat.js` ghi
     lại sau đó, thì giỏ dựng sẵn thiếu/thừa `_ms_*` so với trạng thái hiện tại — vứt. Không có
     gì dựng lại giỏ trước lúc bấm: giỏ bị vứt ở cú bấm và `taoGioRieng` chạy ngay trên đường
     bấm, chậm thêm ~1 giây. Cố ý KHÔNG đưa GIÁ TRỊ `_ms_cid`/`_ms_sid` vào: `ms_sid` đổi giá trị
     khi khách để yên màn chào hàng quá 30 phút mà vẫn còn cookie, vứt cả giỏ vì thế thì mất
     ~1 giây để lấy về cái không đổi gì đáng kể. Giỏ dựng sẵn mang `_ms_sid` cũ trong ca đó là
     chấp nhận có chủ ý (đơn vẫn nối đúng khách). */
  function chuKyGio(ma, maPhien, bai, t, email) {
    var khach = layThuocKhach();
    return [ma, maPhien, bai ? String(bai.length) : '0', t, email,
            JSON.stringify(thuEmail(ma)),
            (khach._ms_cid ? '1' : '0') + (khach._ms_sid ? '1' : '0') + (khach._ms_c || '-')].join('|');
  }

  function maGoi(maBienThe) {
    return (typeof maBienThe === 'string' && /^\d+$/.test(maBienThe)) ? maBienThe : variantGoi;
  }

  function dungSanGio(maBienThe) {
    if (!veCuaHang) return;                       /* Đường giỏ chung ghi vào giỏ thật — không dựng trước được. */
    var ma = maGoi(maBienThe);
    if (!ma) return;
    /* Cổng chặn xét CHỮ KÝ chứ không chỉ mã gói. Xét mỗi mã gói thì bản dựng sớm (chưa có mã
       phiên) coi như đã xong việc, và lần gọi lại sau khi mã phiên về sẽ thoát ngay ở đây —
       giỏ sẵn mãi thiếu mã rồi bị vứt đúng lúc khách bấm, tức mất sạch phần dựng sẵn, im lặng. */
    if (gioSan && gioSan.maDat === ma &&
        gioSan.chuKy === chuKyGio(ma, layPhien(), layBai(), truc(), layEmail())) return;
    if (gioSanDangBay) return;

    var p = window.__msPhienDangBay;
    var xongPhien = coHan(p, TRAN_DUNG_SAN_MS);

    /* Lượt gửi bài về SAU khi đã quá hạn: dựng lại ngay, đừng đợi tới lúc khách bấm. Cổng chặn
       ở trên tự lọc lần gọi thừa khi giỏ hiện tại đã đúng chữ ký. */
    if (p && typeof p.then === 'function') {
      var dungLai = function () { setTimeout(function () { dungSanGio(maBienThe); }, 0); };
      p.then(dungLai, dungLai);
    }

    gioSanDangBay = xongPhien.then(function () {
      var maPhien = layPhien(), bai = layBai(), t = truc(), email = layEmail();
      var ck = chuKyGio(ma, maPhien, bai, t, email);
      return taoGioRieng(ma, maPhien, bai, t, email).then(function (url) {
        gioSan = url ? { chuKy: ck, maDat: ma, url: url } : null;
        gioSanDangBay = null;
      });
    })['catch'](function () { gioSanDangBay = null; });
  }

  /* Giỏ sẵn chỉ dùng được khi đúng gói VÀ mọi phần trong chữ ký còn y nguyên. */
  function urlGioSan(maBienThe) {
    if (!gioSan) return '';
    var ma = maGoi(maBienThe);
    if (gioSan.maDat !== ma) return '';
    var ckGio = chuKyGio(ma, layPhien(), layBai(), truc(), layEmail());
    return gioSan.chuKy === ckGio ? gioSan.url : '';
  }

  function muaNgay(nut, maBienThe) {
    batDauChay(nut);

    /* Đường nhanh: giỏ đã dựng sẵn và còn khớp → chỉ còn một bước điều hướng. */
    var san = urlGioSan(maBienThe);
    if (san) { window.location.assign(giuUtm(san)); return; }

    /* Lượt dựng sẵn đang bay thì đợi nó thay vì đẻ thêm một giỏ nữa. */
    if (gioSanDangBay) {
      coHan(gioSanDangBay, DOI_PHIEN_TOI_DA_MS).then(function () {
        var lai = urlGioSan(maBienThe);
        if (lai) { window.location.assign(giuUtm(lai)); return; }
        /* ĐÃ tiêu hết ngân sách chờ ở trên — `duongThuong()` không được chờ thêm lượt nữa.
           Đo trên Chrome thật 16/09/2026 trước khi sửa: hai lần chờ 1.500 ms nối tiếp cộng
           `taoGioRieng` ~1 giây làm cú bấm mất **4.978 ms** mới nhúc nhích, trong khi bấm lúc
           giỏ đã sẵn chỉ mất **8 ms**. Trần là ngân sách của CẢ cú bấm, không phải của từng chặng. */
        duongThuong(nut, maBienThe, true);
      });
      return;
    }

    duongThuong(nut, maBienThe);
  }

  /* Đợi một promise nhưng không quá `ms`. */
  function coHan(p, ms) {
    if (!p || typeof p.then !== 'function') return Promise.resolve();
    return new Promise(function (xong) {
      var t = setTimeout(xong, ms);
      p.then(function () { clearTimeout(t); xong(); }, function () { clearTimeout(t); xong(); });
    });
  }

  function duongThuong(nut, maBienThe, daChoRoi) {
    /* Chưa có mã mà cũng không lượt nào đang bay = mọi lần gửi trước đã hỏng. Gửi lại một
       lượt rồi mới đợi — `doiPhien()` vẫn giữ trần, nên nút không chết vì nó. */
    if (!layPhien() && !window.__msPhienDangBay && typeof window.__msGuiLai === 'function') {
      try { window.__msGuiLai(); } catch (e) {}
    }
    if (daChoRoi) { muaNgayVoiPhien(nut, maBienThe, layPhien()); return; }
    doiPhien().then(function () { muaNgayVoiPhien(nut, maBienThe, layPhien()); });
  }

  /* Email khách đã gõ trong quiz. `state` là biến toàn cục của bản quiz gốc; đọc trong
     try/catch vì nút này còn được gọi từ màn bán khi `state` chưa dựng. */
  function layEmail() {
    try {
      return (typeof state === 'object' && state && state.email) ? String(state.email).trim() : '';
    } catch (e) { return ''; }
  }

  /* Bốn thuộc tính ẨN cho mẫu email Order confirmation (`docs/email-giao-ban-doc.md`): tên,
     vùng thấp nhất, lựa chọn câu 2/3, cờ bỏ qua ngày sinh — đúng giá trị màn 39 in, do
     `window.__msThuEmail` (`quiz-bo-de-dung-man.js`) cấp. Cho CẢ HAI variant của bản đọc:
     gói mặc định $4.90 và variant $19 mà màn 37 dùng khi hết giờ giữ giá (A2, 22/09) — đó
     là cùng một bản đọc, thiếu bốn khoá này thì email đơn $19 mất khối bản đọc. Hàm kia chưa
     nạp hoặc hỏng thì trả rỗng — giỏ vẫn đi, email chỉ bớt câu. */
  var KHOA_EMAIL = ['_ms_ten', '_ms_vung', '_ms_chon', '_ms_bo_ngay_sinh'];

  function thuEmail(ma) {
    var ra = {};
    if ((ma !== variantGoi && ma !== variantGoiCao) || !ma ||
        typeof window.__msThuEmail !== 'function') return ra;
    try {
      var g = window.__msThuEmail() || {};
      for (var i = 0; i < KHOA_EMAIL.length; i++) {
        var v = g[KHOA_EMAIL[i]];
        if (typeof v === 'string' && v) ra[KHOA_EMAIL[i]] = v;
      }
    } catch (e) {}
    return ra;
  }

  /* ─────────────────────────────────────────────────────────────────────────
     GIỎ RIÊNG CHO ĐƯỜNG MUA NGAY

     Vấn đề đường cũ: `/cart/add.js` ghi vào GIỎ CHUNG của khách, nên màn thanh toán gồm cả
     món khách đã bỏ vào giỏ từ trước. Không phải lỗi mới — `/checkout` xưa nay vẫn vậy — mà
     là sai mô hình: nút này là "mua ngay", một món, không phải "thanh toán giỏ hàng".

     Xoá giỏ trước khi thêm thì cô lập được, nhưng mất hàng khách đang giữ. Storefront API
     `cartCreate` dựng một giỏ ĐỘC LẬP, không đụng cookie `cart` của trình duyệt: đo 09/09/2026
     trên production — vào `checkoutUrl` xong `/cart.js` vẫn trả nguyên giỏ cũ.

     Ba thứ đã chốt đều đi được qua đây, đã đo cùng ngày:
       · `attributes` cấp giỏ  → thuộc tính cấp đơn (Layer 1 của webhook đọc `note_attributes`)
       · `lines[].attributes`  → property dòng hàng (`Your focus`, `_quiz_session`)
       · `buyerIdentity.email` → điền sẵn ô Contact ở checkout

     Cái cuối là lý do tồn tại của cả đường này, và permalink `/cart/<variant>:1` KHÔNG làm
     được: Shopify trả thẳng "properties parameter is invalid".

     Hụt thì trả chuỗi rỗng, người gọi rơi về đường giỏ chung. */
  function taoGioRieng(ma, maPhien, bai, t, email) {
    var dong = { merchandiseId: 'gid://shopify/ProductVariant/' + ma, quantity: 1 };
    var thuoc = [];
    if (t) thuoc.push({ key: 'Your focus', value: t });
    if (maPhien) thuoc.push({ key: '_quiz_session', value: maPhien });
    if (thuoc.length) dong.attributes = thuoc;

    var vao = { lines: [dong] };
    var thuocGio = [];
    if (maPhien) thuocGio.push({ key: 'quiz_session', value: maPhien });
    if (bai) thuocGio.push({ key: '_quiz_ans', value: bai });
    var thu = thuEmail(ma);
    for (var k in thu) { if (thu.hasOwnProperty(k)) thuocGio.push({ key: k, value: thu[k] }); }
    var khach = layThuocKhach();
    if (khach._ms_cid) thuocGio.push({ key: '_ms_cid', value: khach._ms_cid });
    if (khach._ms_sid) thuocGio.push({ key: '_ms_sid', value: khach._ms_sid });
    if (khach._ms_c) thuocGio.push({ key: '_ms_c', value: khach._ms_c });
    if (thuocGio.length) vao.attributes = thuocGio;
    if (email) vao.buyerIdentity = { email: email };

    return fetch('/api/' + BAN_API_CUA_HANG + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': veCuaHang
      },
      body: JSON.stringify({
        query: 'mutation($input:CartInput!){cartCreate(input:$input){cart{checkoutUrl}userErrors{message}}}',
        variables: { input: vao }
      })
    }).then(function (res) {
      return res.ok ? res.json() : null;
    }).then(function (kq) {
      var gio = kq && kq.data && kq.data.cartCreate;
      /* `userErrors` rỗng mà vẫn không có `checkoutUrl` là chuyện không nên xảy ra; xử như
         hỏng để rơi về đường cũ thay vì điều hướng tới `undefined`. */
      if (!gio || (gio.userErrors && gio.userErrors.length)) return '';
      return (gio.cart && typeof gio.cart.checkoutUrl === 'string') ? gio.cart.checkoutUrl : '';
    })['catch'](function () { return ''; });
  }

  /* Đường cũ: thêm vào giỏ chung rồi mở lại đúng giỏ đó qua `/cart/c/<token>`.

     Giữ làm lưới đỡ cho `taoGioRieng`, và là đường DUY NHẤT khi chưa khai vé Storefront API.
     KHÔNG dùng `/checkout?checkout[email]=`: đo trên minespirit.com 09/09/2026, `/checkout`
     redirect sang `/checkouts/cn/<token>` và bỏ luôn query string, ô Contact vẫn rỗng. */
  function duongGioChung(nut, ma, maPhien, bai, t, email) {
    var dong = { id: Number(ma), quantity: 1 };
    if (t) dong.properties = { 'Your focus': t };

    /* Mã phiên ghi THÊM một bản xuống dòng hàng, ngoài bản ở thuộc tính cấp đơn.

       Vì sao phải hai chỗ: webhook bên API đọc `note_attributes` (bản cấp đơn) để mở khoá —
       giữ nguyên, đừng đụng. Nhưng TRANG TÀI KHOẢN của khách thì không đọc được chỗ đó:
       `Order` của Customer Account API không có `customAttributes`, chỉ `LineItem` mới có
       (tra 01/09). Muốn khách đăng nhập vào là mở lại được bản đọc thì mã phải nằm ở dòng hàng.

       Tên bắt đầu bằng `_` để Shopify ẩn khỏi giỏ, trang thanh toán và email đơn — khách không
       có việc gì với một chuỗi uuid. */
    if (maPhien) {
      dong.properties = dong.properties || {};
      dong.properties._quiz_session = maPhien;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [dong] })
    }).then(function (res) {
      if (!res.ok) throw new Error('add ' + res.status);
      /* Gắn mã phiên SAU khi thêm hàng: `/cart/update.js` lên khách chưa có giỏ sẽ TẠO giỏ mới
         (đo 29/09/2026), chạy đua với `/cart/add.js` thì có thể ra hai giỏ. */
      return ganPhienVaoGio(maPhien, bai);
    }).then(function () {
      /* Bốn thuộc tính email đi một lượt RIÊNG, sau lượt gắn mã phiên — `quiz_session` và
         `_quiz_ans` ở lượt kia giữ nguyên từng byte (lượt đó nay còn chở thêm `_ms_cid`/
         `_ms_sid`). Giỏ chung có thể còn giá trị của lượt mua bỏ dở trước đó, nên gửi ĐỦ bốn
         khoá, khoá không có giá trị thì chuỗi rỗng để đè bản cũ. Hỏng thì bỏ qua. */
      var thu = thuEmail(ma), gui = {};
      for (var i = 0; i < KHOA_EMAIL.length; i++) gui[KHOA_EMAIL[i]] = thu[KHOA_EMAIL[i]] || '';
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: gui })
      })['catch'](function () {});
    }).then(function () {
      if (!email) { window.location.assign(giuUtm('/checkout')); return; }
      return layTokenGio().then(function (token) {
        if (!token) { window.location.assign(giuUtm('/checkout')); return; }
        var sep = token.indexOf('?') === -1 ? '?' : '&';
        window.location.assign(giuUtm(
          '/cart/c/' + token + sep + 'checkout[email]=' + encodeURIComponent(email)
        ));
      });
    })['catch'](function () {
      /* Hết hàng, mất mạng, hoặc mã biến thể sai. Đừng để khách kẹt ở nút chết —
         trả về đường cũ, trang bán vẫn mua được. Trả cả CHỮ trên nút về bản gốc: bỏ mỗi
         `disabled` thì nút sáng lại nhưng vẫn ghi "Taking you to checkout…", mà lúc này
         không còn ai đi tới checkout nữa. */
      thoiChay(nut);
      diThoi();
    });
  }

  function muaNgayVoiPhien(nut, maBienThe, maPhien) {
    /* Gọi không kèm mã → gói thấp, đúng hành vi cũ của mọi nút đang gọi hàm này.
       Mã lạ (không phải chuỗi số) cũng rơi về gói thấp thay vì gửi NaN cho `/cart/add.js`.
       Dùng chung `maGoi()` với giỏ dựng sẵn: hai bản chép của cùng một công thức mà lệch nhau
       thì chữ ký khớp trong khi gói đã khác — đơn sai gói, không lỗi nào báo. */
    var ma = maGoi(maBienThe);

    /* Đọc mã phiên và trục MỘT lần rồi dùng cho cả hai đường: đọc hai lần là hai lần có thể
       ra hai kết quả — đúng cách đơn #1022 thành nửa nọ nửa kia. */
    var t = truc();
    var email = layEmail();
    var bai = layBai();

    if (!veCuaHang) { duongGioChung(nut, ma, maPhien, bai, t, email); return; }

    taoGioRieng(ma, maPhien, bai, t, email).then(function (dich) {
      if (dich) { window.location.assign(giuUtm(dich)); return; }
      duongGioChung(nut, ma, maPhien, bai, t, email);
    });
  }

  /* ─────────────────────────────────────────────────────────────────────────
     SỬA HAI CHỖ MÀN BÁN ĐANG NÓI SAI

     1. MÃ GIẢM GIÁ KHÔNG CÓ THẬT. `promoCode()` của quiz ghép tên khách với tháng năm
        ngay trong trình duyệt (Margaret + AUG2026 → MARGARET_AUG2026). Không có mã nào
        như thế trong cửa hàng — đã soi 20 mã thật, toàn SPIRIT10 / WELCOME10 / SUMMER35.
        Mã theo tên từng khách thì cũng không thể tạo trước.
        Trước đây vô hại vì quiz tự lo cả màn thanh toán giả. Nay nút đi thẳng checkout
        thật, khách thấy tick xanh "code applied" rồi sang trang không có mã nào — vênh.
        Bỏ tick và chữ "áp mã", giữ ý "giá đang giữ cho bạn" để không mất sức thuyết phục.

     2. GIÁ LỆCH. Màn bán ghi $9.99, gói tính $4.90. Khách trả ít hơn nên không thiệt,
        nhưng hai con số vênh nhau trong một luồng thì trông cẩu thả.

     Sửa trên DOM sau khi quiz vẽ xong, không đụng file quiz bê nguyên.
     ───────────────────────────────────────────────────────────────────────── */
  var GIA_CU = '$9.99';
  var GIA_MOI = '$4.90';
  var MA_GIA = /^[A-Z]{2,}_[A-Z]{3}\d{4}$/;

  /* 03/09/2026 · ĐỪNG đổi giá khi quiz ĐÃ TỰ dựng bậc giá.
     Bản v3 (lớp `v12pPrice`) khai `S.list = '$9.99'` làm giá GẠCH NGANG và
     `S.price = '$4.90'` làm giá thật — tức $9.99 nay là một BẬC trong thang
     $100 -> $9.99 -> $4.90, không còn là "giá sai" như bản 28/08.

     Thay mù thì màn mua in ra hai con số giống hệt nhau nằm cạnh nhau. Đo trên nhánh này
     ngày 03/09, TRƯỚC khi vá, trên trình duyệt thật:
       .f7apply   = "$4.90 -> $4.90"
       hàng giá   = <s>$4.90</s> <s>$100</s> <s>$4.90</s> <u>$4.90</u>
       chuỗi "$9.99" còn trên màn: 0 lần

     Dòng "your code is applied" thì VẪN đổi — mã giảm giá vẫn là mã giả. */
  function quizDaDatGia() {
    try { return PQ().sale.price === GIA_MOI; } catch (e) { return false; }
  }

  function doiChu(goc_el) {
    var daDatGia = quizDaDatGia();
    var duyet = document.createTreeWalker(goc_el, NodeFilter.SHOW_TEXT, null);
    var n, dsach = [];
    while ((n = duyet.nextNode())) dsach.push(n);
    for (var i = 0; i < dsach.length; i++) {
      var t = dsach[i];
      if (!daDatGia && t.nodeValue.indexOf(GIA_CU) !== -1) {
        t.nodeValue = t.nodeValue.split(GIA_CU).join(GIA_MOI);
      }
      if (/code is applied/i.test(t.nodeValue)) {
        t.nodeValue = t.nodeValue.replace(/your code is applied/i, 'Your price is held for you');
      }
    }
  }

  /* Mã giả nằm trong `<div class="f7code"><span class="f7tick">\u2713</span>MARGARET_AUG2026</div>`
     — mã là text node TRẦN, còn thẻ bọc nó có một con là dấu tick. Bản trước tìm phần tử
     `children.length === 0` nên không bao giờ khớp: ô tick xanh vẫn hiện nguyên.
     Khách bỏ trống tên thì mã rút còn `AUG2026`, không có gạch dưới — regex phải nhận cả hai. */
  var MA_GIA = /^([A-Z]{2,}_)?[A-Z]{3}\d{4}$/;

  function boMaGia(goc_el) {
    var duyet = document.createTreeWalker(goc_el, NodeFilter.SHOW_TEXT, null);
    var n, dsach = [];
    while ((n = duyet.nextNode())) dsach.push(n);
    for (var i = 0; i < dsach.length; i++) {
      var t = dsach[i];
      if (!MA_GIA.test((t.nodeValue || '').trim())) continue;
      var cha = t.parentElement;
      if (!cha) continue;
      var o = cha.closest('.f7code, .promo') || cha;
      o.style.display = 'none';   /* Ẩn cả ô: trong đó còn dấu tick, để lại là vẫn hứa hão. */
      return;
    }
  }

  /* "Demo only \u00b7 no payment processed" nằm ngay dưới nút mua (`.f7demo`; bản cũ dùng
     `.demoflag`). Câu đó đúng khi quiz còn là bản trình diễn trên Cloudflare — trên cửa hàng
     thì nút này đi thẳng `/cart/add.js` -> `/checkout`, tiền thu THẬT. Để lại là tự bảo khách
     "chỗ này không thu tiền" đúng giây họ trả tiền.

     Ẩn cả khối chứ không sửa chữ: chữ nằm trong file bê nguyên, sửa ở đó là lần bê sau mất vá.
     ⚠️ Lỗi này CÓ SẴN trên bản đang chạy, không phải do bản v3 sinh ra. */
  function boChuDemo(goc_el) {
    var ds = goc_el.querySelectorAll('.f7demo, .demoflag');
    for (var i = 0; i < ds.length; i++) ds[i].style.display = 'none';
  }

  function suaChu() {
    var kh = document.getElementById('scr') || document.getElementById('phone');
    if (!kh) return;
    doiChu(kh);
    boMaGia(kh);
    boChuDemo(kh);
  }

  /* Ba nút cùng một việc trên màn bán: nút chính, nút giữa trang, nút dính đáy. */
  var NUT = ['buy', 'buy2', 'cdgo'];

  /* Ghi biểu đồ và lá số NGAY KHI tới màn bán, không đợi lúc rời trang.
     Trước đây `guiBanDo()` chỉ nằm trong `diThoi()` — đường chuyển sang trang bán. Từ khi
     nút đi thẳng thanh toán, `diThoi()` chỉ còn là đường lui khi lỗi, nên không lần nào ghi:
     đo trên live 29/08 ở màn bán, `localStorage.minespirit_ban_do` RỖNG.
     Ghi ở đây thì mọi lối đều có dữ liệu — mua thẳng, hay vòng qua trang bán sau. */
  function ghiBanDo() {
    try {
      /* KHÔNG chặn ghi đè. Máy dùng chung — đúng nỗi lo đã ghi ở đầu file — người sau làm
         quiz mà thấy biểu đồ và lá số của người trước là hỏng nặng hơn nhiều so với ghi
         thừa một lần. `guiBanDo` đã tự bỏ qua dữ liệu rỗng nên không sợ đè bản tốt bằng
         bản trống. */
      guiBanDo(res7() || {});
    } catch (e) { /* Chưa trả lời câu nào, hoặc trình duyệt chặn lưu trữ. Bỏ qua. */ }
  }

  function gan() {
    ghiBanDo();
    for (var i = 0; i < NUT.length; i++) {
      var n = document.getElementById(NUT[i]);
      if (!n || n.getAttribute('data-da-gan') === '1') continue;
      n.setAttribute('data-da-gan', '1');
      n.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        muaNgay(e.currentTarget);
      }, true);
    }
  }

  if (variantGoi) {
    var render_goc = RENDER.sale4;
    RENDER.sale4 = function () {
      var kq = render_goc.apply(this, arguments) || {};
      var bindGoc = kq.bind;
      kq.bind = function () {
        if (typeof bindGoc === 'function') bindGoc();
        try { gan(); } catch (e) { /* Không gắn được thì nút chạy đường gốc của quiz. */ }
        try { suaChu(); } catch (e) { /* Sửa hụt thì để nguyên chữ, đừng làm vỡ màn. */ }
      };
      return kq;
    };
    /* Vào thẳng bằng ?screen=<sale4>: màn đã dựng trước khi file này chạy. */
    try {
      if (typeof cur === 'number' && SCREENS[cur] && SCREENS[cur].t === 'sale4') { gan(); suaChu(); }
    } catch (e) {}
  } else {
    RENDER.sale4 = function () {
      diThoi();
      return { html: '<div class="mid center"><div class="moonart"></div></div>' };
    };
    try {
      if (typeof cur === 'number' && SCREENS[cur] && SCREENS[cur].t === 'sale4') diThoi();
    } catch (e) {}
  }

  /* Phơi hai đường ĐI TỚI THANH TOÁN ra ngoài cho `quiz-giai-doan-1.js`.

     Từ 08/09/2026 màn `sale4` không còn trong `SCREENS` — nút mua nằm trong khối chào hàng
     của màn kết quả mới. Nhưng đường đi tới tiền thì KHÔNG được chép lại: `muaNgay()` gắn
     mã phiên ở CẢ thuộc tính cấp đơn (webhook API đọc để mở khoá bản đọc) lẫn dòng hàng
     (trang tài khoản khách chỉ đọc được chỗ này), và cả hai đều đã trả giá ở đơn #1016/#1017
     mới tìm ra. Hai bản sao của một đường như thế sẽ lệch nhau ở lần sửa thứ nhất.

     `muaNgay` chỉ tồn tại khi có `data-variant-goi`; `diThoi` là đường lui sang trang bán. */
  window.__msMuaNgay = (typeof variantGoi === 'string' && variantGoi) ? muaNgay : null;
  /* Mã gói cao, để `quiz-giai-doan-1.js` biết CÓ ĐƯỢC bày hai gói hay không. Chuỗi rỗng
     nghĩa là chưa cấu hình — bên kia phải tự lo, đừng bày lựa chọn không mua được. */
  window.__msVariantCao = variantGoiCao;
  window.__msSangTrangBan = diThoi;
  /* Cho `quiz-giai-doan-1.js` gọi lúc khối chào hàng dựng xong và mỗi lần khách đổi gói.
     Gọi thừa là vô hại: hàm tự thoát khi đã có sẵn giỏ đúng gói hoặc đang dựng dở. */
  window.__msDungSanGio = (typeof variantGoi === 'string' && variantGoi) ? dungSanGio : null;
})();

/* ═══════════════════════════════════════════════════════════════════════════
 * KHOÁ PHẦN LUẬN GIẢI Ở BẢN ĐỌC MIỄN PHÍ
 *
 * Cơ chế bán của cả phễu: cho khách phần THẤY, giữ lại phần HIỂU. Bản $0 mà giải
 * thích rõ quá thì không còn gì để bán.
 *
 * Đo bản gốc ngày 28/08 (`?demo=margaret&screen=43`): màn báo cáo trả 10.702 ký tự,
 * KHÔNG có ổ khoá nào. Trong đó hai mục nặng nhất là phần hiểu:
 *   mục 4 "IF THIS CARRIES ON"      3.990 ký tự — hệ quả nếu cứ thế này
 *   mục 5 "WHAT TO DO — FIVE DOORS" 2.197 ký tự — phải làm gì
 * Cộng lại 6.187 ký tự, tức 58% bản đọc, cho không.
 *
 * ĐỂ LẠI (phần THẤY): tên và ngày sinh · bốn ô chỉ số · mục 1 đếm hoàn cảnh ·
 * mục 2 biểu đồ bảy tầng · mục 3 trích lại chính câu trả lời của khách.
 * Những mục này mô tả, không diễn giải — khách thấy mình trong đó mà chưa hiểu vì sao.
 *
 * CẮT Ở ĐÂU: giữ đúng đoạn văn ĐẦU TIÊN của mục 4. Đó là câu đúc kết dạng nỗi đau
 * ("Nothing dramatic happens next…") — thứ làm khách muốn đọc tiếp. Phần còn lại của
 * mục 4 và trọn mục 5 nằm sau ổ khoá.
 *
 * KHÔNG sửa file quiz bê nguyên. Bọc `RENDER.docReport` từ ngoài, cùng lối với
 * `RENDER.sale4` ở trên: quiz nâng cấp thì chỉ phải xem lại file này.
 * ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  if (typeof RENDER !== 'object' || typeof RENDER.docReport !== 'function') return;

  /* ── 03/09/2026 · TẮT HẲN KHỐI NÀY TRÊN BẢN v3 ────────────────────────────
     Khối cắt bên dưới dựng cho bản quiz 28/08, mà bản đó — đo ngay trong chú
     thích trên — trả bản đọc 10.702 ký tự và KHÔNG CÓ Ổ KHOÁ NÀO. Không cắt thì
     cho không cả phần hiểu.

     Bản v3 ngược lại: nó TỰ KHOÁ. Mục 6 "Bộ Giải Pháp" mở thẻ 1, khoá 4 thẻ còn
     lại (`v10sSolCard(s, true)`); còn có `restc lockmini` xen giữa và khối chào
     bán ở cuối. Cắt thêm một lần nữa là cắt chồng, và cắt nhầm chỗ: mốc
     `.dsec.b4hit` ở v3 là mục 5 "Kết Luận", nên mọi thứ từ mục 6 trở đi bay sạch
     — kể cả ẢNH BỘ HỘP và hai ô ảnh sản phẩm, tức đúng phần dựng ra để bán.

     Đo trên bàn thử 03/09 (hồ sơ margaret):
       docReport  151.138 -> 13.778 ký tự,  ảnh hộp 0
       docMap     202.695 -> 44.317 ký tự,  ảnh hộp 0
       reportFull 148.419 ->  9.366 ký tự   (cắt cả bản ĐÃ TRẢ TIỀN)

     Nhận diện bản v3 bằng hai thứ chỉ v3 mới có: bảng tầng→hộp và hàm dựng thẻ
     giải pháp có tham số khoá. Bản cũ không có cái nào, nên nó vẫn được cắt như
     trước — file này chạy đúng cho cả hai bản.

     Phần chuyển sang trang bán Shopify (IIFE ở TRÊN) KHÔNG bị ảnh hưởng. */
  var LA_V3 = (typeof TIER2BOX !== 'undefined') && (typeof v10sSolCard === 'function');

  var goc = RENDER.docReport;

  /* ─────────────────────────────────────────────────────────────────────────
     LỜI MỜI, KHÔNG PHẢI Ổ KHOÁ

     Ổ khoá nói với khách "bạn chưa đủ tư cách" — nó chia người đọc thành hạng đã trả
     và hạng chưa trả ngay giữa lúc họ đang xúc động vì vừa đọc về chính mình. Lời mời
     nói "còn phần này viết riêng cho bạn". Cùng một việc chặn nội dung, khác hẳn chỗ
     khách đứng khi bấm nút. Nên: không biểu tượng khoá, không chữ "unlock/locked",
     không dựng giá gạch ngang giả.

     Một hàm dựng khung dùng chung cho cả bản báo cáo lẫn bản đồ. Trước đây hai chỗ
     dựng riêng nên lệch nhau — sửa một chỗ mà chỗ kia vẫn cũ.
     ───────────────────────────────────────────────────────────────────────── */
  var CO = '224,184,114';              /* vàng của trang, lấy từ tiêu đề thẻ hành tinh */

  /* Đường sang trang bán. Đọc lại `data-dich-ban` của section, cùng luật kiểm với khối
     trên: chỉ nhận đường dẫn nội bộ, gõ nhầm địa chỉ ngoài thì bỏ nút chứ không đẩy
     khách sang site lạ. */
  function dichMua() {
    try {
      var g = document.querySelector('[data-dich-ban]');
      var d = g && (g.getAttribute('data-dich-ban') || '').trim();
      if (!d || d.charAt(0) !== '/' || d.charAt(1) === '/') return '';
      return d;
    } catch (e) { return ''; }
  }

  function napCss() {
    if (document.getElementById('qmoi-css')) return;
    var st = document.createElement('style');
    st.id = 'qmoi-css';
    st.textContent =
      '.qmoi__in{text-align:center;padding:26px 20px;border-radius:18px;' +
        'border:1px solid rgba(' + CO + ',.34);' +
        'background:linear-gradient(180deg,rgba(' + CO + ',.15),rgba(' + CO + ',.04))}' +
      '.qmoi .qmoi__h{margin:0 0 8px;font-weight:700;color:rgb(' + CO + ')}' +
      '.qmoi__p{margin:0 auto 16px;opacity:.8;max-width:46ch}' +
      '.qmoi__nut{display:inline-block;padding:13px 28px;border-radius:999px;' +
        'background:linear-gradient(180deg,rgb(' + CO + '),rgb(198,158,92));' +
        'color:#221a34;font-weight:700;text-decoration:none}' +
      '.qmoi__qua{margin-right:8px}' +
      '.qmoi__gia{margin:12px 0 0;font-size:.85em;opacity:.6}' +
      '.qdai{margin:14px 0 0}' +
      '.qdai__a{display:flex;align-items:center;justify-content:space-between;gap:12px;' +
        'padding:11px 15px;border-radius:12px;text-decoration:none;color:inherit;' +
        'background:rgba(' + CO + ',.10);border:1px solid rgba(' + CO + ',.26)}' +
      '.qdai__c{opacity:.78;font-size:.92em;text-align:left}' +
      '.qdai__m{color:rgb(' + CO + ');font-weight:700;white-space:nowrap;font-size:.92em}';
    document.head.appendChild(st);
  }

  /* Quiz bê nguyên gọi nút của nó là "🔓 Unlock everything" — vẫn là chữ của ổ khoá, và nó
     DÍNH ĐÁY nên khách thấy nó ở mọi màn. Dựng lời mời tử tế phía trên mà dưới chân vẫn treo
     cái khoá thì công cốc. Đổi chữ, giữ nguyên nút và mọi thứ gắn vào nó.
     Không thấy nút thì thôi — bản quiz đổi id, thà để chữ cũ còn hơn làm vỡ màn. */
  var QUA = '\u{1F381} ';
  var CHU_NUT = { unlock: QUA + 'Read my full reading', ctabtn: QUA + 'Read it all + take the gifts' };

  function boChuKhoa() {
    for (var id in CHU_NUT) {
      var n = document.getElementById(id);
      if (!n || n.getAttribute('data-da-doi') === '1') continue;
      n.textContent = CHU_NUT[id];
      n.setAttribute('data-da-doi', '1');
    }
  }

  /* ── 03/09/2026 · NHÁNH BẢN v3 — thoát ở ĐÂY, không thoát ở đầu khối ───────────
     Trên v3 KHÔNG cắt bản đọc nữa (v3 tự khoá, và mốc `.dsec.b4hit` ở v3 là mục 5 nên cắt
     là bay cả ảnh bộ hộp). Nhưng thoát ngay đầu khối thì mất luôn `boChuKhoa()` — nút quay
     về chữ ổ khoá "\u{1F513} Unlock everything", đúng thứ quyết định 31/08 đã gạch đi.
     Nên thoát ở đây: giữ phần đổi chữ nút, bỏ toàn bộ phần cắt.

     KHÔNG hồi sinh `khungMoi()` và `noiVaoManBan()`, dù chúng nằm sau chỗ này:
       · `.qmoi` là nút mời thứ ba thừa — v3 đã có `#ctabtn` và `.restc` đi thẳng `sale4`;
       · `#unlock` của v3 (lớp v6h) bấm lần đầu chỉ CUỘN xuống `.ctac` nếu thẻ chưa lộ 80%
         màn hình, nên `u.click()` của `noiVaoManBan` sẽ ra cuộn chứ không đổi màn.

     Gọi thẳng một lần cho lối vào `?screen=`, rồi quan sát `#app` cho mọi lần vẽ lại —
     cùng lối với vòng quan sát ở cuối file, vì quiz vẽ lại bằng `innerHTML` và không bắn
     sự kiện nào. `boChuKhoa` tự chặn chạy trùng bằng `data-da-doi` nên gọi thừa là vô hại. */
  if (LA_V3) {
    try { boChuKhoa(); } catch (e) {}
    try {
      var khungV3 = document.getElementById('app') || document.body;
      if (khungV3 && typeof MutationObserver === 'function') {
        new MutationObserver(function () {
          try { boChuKhoa(); } catch (e) {}
        }).observe(khungV3, { childList: true, subtree: true });
      }
    } catch (e) { /* Trình duyệt cũ — chữ nút giữ nguyên bản gốc, không vỡ gì. */ }
    return;
  }

  /* Nút mời phải đi CÙNG ĐƯỜNG với nút `#unlock` sẵn có của quiz: sang màn bán của
     chính quiz, rồi từ đó `gan()` đưa thẳng ra checkout. Đo trên live 31/08: bấm
     `#unlock` -> `SCREENS[42].t = 'sale4'`, có đủ ba nút `buy/buy2/cdgo` đã gắn.

     Trước đó nút mời trỏ thẳng `href` sang trang bán Shopify — thêm một lần tải trang
     và bỏ qua màn bán của quiz. Đúng chỗ Mến bắt được khi thử trên điện thoại.

     Giữ `href` làm đường lui: không có `#unlock` (quiz đổi id, hoặc JS chặn) thì thẻ
     neo vẫn chạy như thẻ neo thường, khách vẫn mua được. */
  function noiVaoManBan(a) {
    if (!a) return;
    a.addEventListener('click', function (e) {
      var u = document.getElementById('unlock');
      if (!u) return;                 /* Để `href` gốc lo. */
      e.preventDefault();
      u.click();
    });
  }

  /* Khung mời cỡ lớn — đặt ở cuối, chỗ khách đã đọc hết phần cho không. */
  function khungMoi(tieu, mo) {
    napCss();
    var d = dichMua();
    var o = document.createElement('div');
    o.className = 'dsec qmoi';
    o.innerHTML =
      '<div class="qmoi__in">' +
        '<p class="qmoi__h"></p><p class="qmoi__p"></p>' +
        (d ? '<a class="qmoi__nut" href="' + d + '">' +
               '<span class="qmoi__qua" aria-hidden="true">\u{1F381}</span>Read my full interpretation</a>' +
             '<p class="qmoi__gia">Your full reading · $4.90</p>' : '') +
      '</div>';
    o.querySelector('.qmoi__h').textContent = tieu;
    o.querySelector('.qmoi__p').textContent = mo;
    noiVaoManBan(o.querySelector('.qmoi__nut'));
    return o;
  }

  /* Dải mời cỡ nhỏ — đặt xen giữa, chỉ nhắc chứ không cắt mạch đọc. */
  function daiMoi(chu) {
    napCss();
    var d = dichMua();
    var e = document.createElement('div');
    e.className = 'qdai';
    if (!d) return e;
    var a = document.createElement('a');
    a.className = 'qdai__a';
    a.href = d;
    var c = document.createElement('span'); c.className = 'qdai__c'; c.textContent = chu;
    var m = document.createElement('span'); m.className = 'qdai__m'; m.textContent = 'Read it →';
    a.appendChild(c); a.appendChild(m); e.appendChild(a);
    noiVaoManBan(a);
    return e;
  }

  /* Giữ tiêu đề mục, bỏ phần diễn giải. `giuDoanDau` = giữ thêm đoạn văn đầu làm câu móc. */
  function chiGiuTieuDe(sec, giuDoanDau) {
    var con = [].slice.call(sec.children);
    var cat = -1, dem = 0;
    for (var i = 0; i < con.length; i++) {
      var la = con[i];
      if (la.className && String(la.className).indexOf('dsech') !== -1) continue;
      if (giuDoanDau && la.tagName === 'P' && la.textContent.trim().length > 40) {
        dem++; if (dem === 1) continue;
      }
      cat = i; break;
    }
    if (cat < 0) return;
    for (var j = con.length - 1; j >= cat; j--) sec.removeChild(con[j]);
  }

  function khoa() {
    var w = document.querySelector('.docwrap');
    if (!w || w.getAttribute('data-da-khoa') === '1') return;

    var m4 = w.querySelector('.dsec.b4hit') || timMuc(w, /^4\b/, /CROSSCURRENT|COSTING/i);
    if (!m4) return; /* Bản quiz đổi lớp — thà không khoá còn hơn cắt nhầm. */

    chiGiuTieuDe(m4, true);

    /* Mục 5 — "phải làm gì" — nằm ngay sau mục 4. Giữ tiêu đề, bỏ ruột: khách nhìn thấy
       thứ mình sắp nhận, thay vì thấy một khoảng trống không rõ mất gì. */
    var m5 = m4.nextElementSibling;
    if (m5 && m5.classList.contains('dsec')) chiGiuTieuDe(m5, false);

    var o = khungMoi(
      'The rest of this is written for your answers.',
      'What that one thin tier is quietly costing you on an ordinary week, and the first ' +
      'thing to change — read against your own chart, not a general profile.');
    (m5 && m5.classList.contains('dsec') ? m5 : m4).insertAdjacentElement('afterend', o);

    try { boChuKhoa(); } catch (e) {}
    w.setAttribute('data-da-khoa', '1');
  }

  /* ─────────────────────────────────────────────────────────────────────────
     BẢN ĐỒ — bốn luật, theo yêu cầu 30/08

     Đo trên live 29/08, màn bản đồ cho không **18.695 ký tự**:
       1 WHO YOU ARE                      3.046   ← giữ VỊ TRÍ sao, ẩn phần diễn giải
       2 THE STRETCHES YOU HAVE WALKED    2.360   ← đã đi qua: giữ nguyên
       3 THE STRETCH AHEAD                3.363   ← giữ 2026, các năm 2027+ để lại lời mời
       4 FIVE CROSSCURRENTS               6.189   ← giữ tiêu đề, bỏ ruột
       5 THE FIVE DOORS                   2.059   ← giữ tiêu đề, bỏ ruột
       6 SPECIAL 2026–2027                1.060   ← giữ tiêu đề, bỏ ruột

     Nguyên tắc chung: khách vẫn được THẤY — vị trí sao, mốc năm, tên từng mục.
     Cái phải trả tiền là phần HIỂU. Thấy mà chưa hiểu mới là thứ làm người ta mua.
     ───────────────────────────────────────────────────────────────────────── */
  function timMuc(w, so, chu) {
    var ds = w.querySelectorAll('.dsec');
    for (var i = 0; i < ds.length; i++) {
      var t = (ds[i].innerText || '').trim();
      if (so.test(t) || chu.test(t.slice(0, 60))) return ds[i];
    }
    return null;
  }

  /* Mục 1 — thẻ hành tinh: `<b>` là vị trí (giữ), `<em>` là phần luận (bỏ). */
  function anLuanThe(m1) {
    var em = m1.querySelectorAll('.pcb em');
    if (!em.length) return;
    for (var i = 0; i < em.length; i++) em[i].parentNode.removeChild(em[i]);
    m1.appendChild(daiMoi('What each of these placements actually means for you.'));
  }

  /* Mục 3 — mốc năm: giữ năm đang sống, các năm sau để lại lời mời. */
  function moiNamSau(m3) {
    var cot = m3.querySelectorAll('.ycol');
    if (!cot.length) return;
    var nay = new Date().getFullYear(), coCat = false;
    for (var i = 0; i < cot.length; i++) {
      var oy = cot[i].querySelector('.yy');
      var nam = oy ? parseInt(oy.textContent, 10) : 0;
      if (!nam || nam <= nay) continue;
      var ch = cot[i].querySelector('.ychar');
      if (ch) { ch.textContent = '···'; ch.style.opacity = '.35'; coCat = true; }
    }
    /* Phần văn diễn giải nằm sau lưới năm — bỏ, giữ lại lưới. */
    var luoi = m3.querySelector('.ygrid');
    var khung = luoi && luoi.parentNode;
    if (khung) {
      var sau = luoi.nextElementSibling;
      while (sau) { var ke = sau.nextElementSibling; khung.removeChild(sau); sau = ke; coCat = true; }
    }
    if (coCat) m3.appendChild(daiMoi('What each year ahead asks of you, one at a time.'));
  }

  function khoaBanDo() {
    var w = document.querySelector('.docwrap');
    if (!w || w.getAttribute('data-khoa-map') === '1') return;
    var m4 = timMuc(w, /^4\b/, /CROSSCURRENT/i);
    if (!m4) return;                       /* Không nhận ra mục — thà không khoá còn hơn cắt nhầm. */

    var ds = [].slice.call(w.querySelectorAll('.dsec'));
    try { if (ds[0]) anLuanThe(ds[0]); } catch (e) {}
    try { var m3 = timMuc(w, /^3\b/, /STRETCH AHEAD|STILL AHEAD/i); if (m3) moiNamSau(m3); } catch (e) {}

    /* Mục 4 giữ đoạn đầu làm câu móc; mục 5, 6 chỉ còn tiêu đề. */
    chiGiuTieuDe(m4, true);
    var cuoi = m4, sau = m4.nextElementSibling;
    while (sau && sau.classList && sau.classList.contains('dsec')) {
      chiGiuTieuDe(sau, false);
      cuoi = sau;
      sau = sau.nextElementSibling;
    }

    cuoi.insertAdjacentElement('afterend', khungMoi(
      'Your reading goes further than this.',
      'The five crosscurrents read in full, the five doors out of them, and the two years ' +
      'ahead in detail — written against your own chart.'));

    try { boChuKhoa(); } catch (e) {}
    w.setAttribute('data-khoa-map', '1');
  }

  if (typeof RENDER.docMap === 'function') {
    var goc_map = RENDER.docMap;
    RENDER.docMap = function () {
      var kq = goc_map.apply(this, arguments) || {};
      var bindGoc = kq.bind;
      kq.bind = function () {
        if (typeof bindGoc === 'function') bindGoc();
        try { khoaBanDo(); } catch (e) {}
      };
      return kq;
    };
    try { khoaBanDo(); } catch (e) {}
    try {
      var khungM = document.getElementById('app') || document.body;
      if (khungM && typeof MutationObserver === 'function') {
        new MutationObserver(function () { try { khoaBanDo(); } catch (e) {} })
          .observe(khungM, { childList: true, subtree: true });
      }
    } catch (e) {}
  }

  RENDER.docReport = function () {
    var kq = goc.apply(this, arguments) || {};
    var bindGoc = kq.bind;
    kq.bind = function () {
      if (typeof bindGoc === 'function') bindGoc();
      /* Chạy sau khi quiz gắn xong DOM của nó, nếu không thì cắt vào chỗ chưa có. */
      try { khoa(); } catch (e) { /* Cắt hụt thì để nguyên bản đọc, đừng làm vỡ màn. */ }
    };
    return kq;
  };

  /* Bản đè ở trên chỉ ăn từ LẦN VẼ SAU. Hai lối đi vòng qua nó, đo trên live 28/08:
     bản đọc vẫn ra đủ 10.253 ký tự, `data-da-khoa` không hề được đặt.

     1. Vào thẳng bằng `?screen=<docReport>`: quiz dựng màn đó ngay trong `boot()`, mà file
        này tải `defer` nên chạy sau — màn đã vẽ xong trước khi có bản đè.
     2. Quiz vẽ lại màn bằng `innerHTML` và không bắn sự kiện nào, nên không có chỗ nào để
        nghe ngoài chính DOM.

     Nên gọi thẳng một lần cho trường hợp 1, rồi quan sát khung app cho mọi lần sau.
     `khoa()` tự chặn chạy hai lần bằng `data-da-khoa`, nên gọi thừa là vô hại và vòng
     quan sát tự dừng: lần cắt sinh ra thay đổi, lần gọi kế tiếp thoát ngay ở cổng đó. */
  try { khoa(); } catch (e) {}

  try {
    var khung = document.getElementById('app') || document.body;
    if (khung && typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        try { khoa(); } catch (e) {}
      }).observe(khung, { childList: true, subtree: true });
    }
  } catch (e) { /* Trình duyệt cũ không có MutationObserver — vẫn còn bản đè ở trên. */ }
})();
